import gql from 'graphql-tag'

export default gql`
{
  labelGroupAll
}
`



// WEBPACK FOOTER //
// ./src/graphql/queries/labelGroupAll.js